<template>
  <TConfigProvider :global-config="globalConfig">
    <RouterView />
  </TConfigProvider>
</template>

<script setup lang="tsx">
import { DialogPlugin, MessagePlugin } from 'tdesign-vue-next'
import enConfig from '@/locales/en/tdesign'
import eventBus from '@/plugins/mitt'

const router = useRouter()
const VITE_PARTNER_OLD_URL = 'https://greenet.ai'
const VITE_PARTNER_NEW_URL = 'https://partner.greensketch.ai'
function authRequiredAlert(error: any) {
  const dialog = DialogPlugin.alert({
    header: error.msg,
    body: 'Your session has expired, please login again to continue.',
    confirmBtn: 'OK',
    theme: 'warning',
    closeOnOverlayClick: false,
    closeBtn: false,
    closeOnEscKeydown: false,
    placement: 'center',
    onConfirm: () => {
      dialog.destroy()
      router.replace('/login')
    },
  })
}

function showModal() {
  // 清除#redirected
  router.replace({
    path: router.currentRoute.value.path,
    query: router.currentRoute.value.query,
  })
  const dialog = DialogPlugin.alert({
    header: 'Important Notice:URL Update',
    body: () => (
      <div class="flex flex-wrap items-center">
        The URL
        <div class="text-#1578d0 underline">greenet.ai</div>
        will be discontinued. Please use the new URL:
        <div class="text-#1578d0 underline">partner.greensketch.ai</div>
        .
      </div>
    ),
    confirmBtn: 'OK',
    closeOnOverlayClick: false,
    closeBtn: false,
    closeOnEscKeydown: false,
    placement: 'center',
    onConfirm: () => {
      window.open(VITE_PARTNER_NEW_URL, '_self')
      // dialog.destroy()
    },
  })
}

onMounted(() => {
  eventBus.once('auth:required', (error: any) => {
    authRequiredAlert(error)
  })

  eventBus.on('server:error', (msg: string) => {
    MessagePlugin.error(msg)
  })

  // 如果是https://greenet.ai的旧地址访问，则弹出提示框
  if (window.location.origin === VITE_PARTNER_OLD_URL) {
    showModal()
  }
  // //  hash判断是不是重定向弹窗
  // if (window.location.hash === '#redirected') {
  //   showModal()
  // }
})

onUnmounted(() => {
  eventBus.off('server:error')
})

const globalConfig: any = {
  ...enConfig,
}
</script>
